<template>
  <div class="patentList fatherHeight contBox">
    <div class="bar-title">基本信息</div>
    <div class="table">
      <div class="patentList fatherHeight contBox">
        <div class="momey-total1">
          <div class="item1">人员编号:{{baseinfo.psn_no}}</div>
          <div class="item">人员证件类型:{{baseinfo.psn_cert_type}}</div>
          <div class="item">证件号码:{{baseinfo.certno}}</div>
          <div class="item">人员姓名:{{baseinfo.psn_name}}</div>
        </div>
        <div class="momey-total1">
          <div class="item1">性别:{{baseinfo.gend}}</div>
          <div class="item">民族:{{baseinfo.naty}}</div>
          <div class="item">出生日期:{{baseinfo.brdy}}</div>
          <div class="item">年龄:{{baseinfo.age}}</div>
        </div>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="patientList" ref="tableBoxRef">
      <div class="list-top flex-between">
        <div class="bar-title">参保信息</div>
      </div>
      <div class="table">
        <div class="patentList fatherHeight contBox">
          <div class="box-info">
            <!-- <table class="info-table" cellspacing="0">
              <tr>
                <td class="color-blue border-right">余额</td>
                <td class="border-right">30</td>
                <td class="color-blue border-right">险种类型</td>
                <td class="border-right">30</td>
                <td class="color-blue border-right">人员类别</td>
                <td class="border-right">30</td>
                
              </tr>
              <tr>
                <td class="color-blue border-right">公务员标志</td>
                <td class="border-right">30</td>
                <td class="color-blue border-right">参保地医保区划</td>
                <td class="border-right">30</td>
                <td class="color-blue border-right">单位名称</td>
                <td class="border-right">30</td>
               
              </tr>
            </table> -->
            <el-table :data="insuinfo" style="width: 100%" max-height="300" border v-loading="loading">
              <el-table-column prop="balc" label="余额" />
              <el-table-column prop="insutype" label="险种类型" />
              <el-table-column prop="psn_type" label="人员类别" />
              <el-table-column prop="psn_insu_stas" label="人员参保状态" />
              <el-table-column prop="psn_insu_date" label="人员参保日期" />
              <el-table-column prop="paus_insu_date" label="暂停参保日期" />
              <el-table-column prop="cvlserv_flag" label="公务员标志" />
              <el-table-column prop="insuplc_admdvs" label="参保地医保区划" />
              <el-table-column prop="emp_name" label="单位名称" />
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="patientList" ref="tableBoxRef">
      <div class="list-top flex-between">
        <div class="bar-title">身份信息</div>
      </div>
      <div class="table">
        <div class="patentList fatherHeight contBox">
          <div class="box-info">
            <!-- <table class="info-table" cellspacing="0">
              <tr>
                <td class="color-blue border-right">人员身份类别</td>
                <td class="border-right">30</td>
                <td class="color-blue border-right">人员类别等级</td>
                <td class="border-right">30</td>
                <td class="color-blue border-right">备注</td>
                <td class="border-right">30</td>
              </tr>
              <tr>
                <td class="color-blue border-right">开始时间</td>
                <td class="border-right">30</td>
                <td class="color-blue border-right">结束时间</td>
                <td class="border-right">30</td>
                <td class=""></td>
                <td class=""></td>


              </tr>
            </table> -->
            <el-table :data="idetinfo" style="width: 100%" max-height="300" border v-loading="loading">
              <el-table-column prop="psn_idet_type" label="人员身份类别" />
              <el-table-column prop="psn_type_lv" label="人员类别等级" />
              <el-table-column prop="begntime" label="开始时间" />
              <el-table-column prop="endtime" label="结束时间" />
              <el-table-column prop="memo" label="备注" />
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    reactive,
    toRefs,
    ref,
    nextTick,
    onMounted,
    onBeforeUnmount,
  } from 'vue'
  import { useRoute } from 'vue-router'
  import service from '@/utils/request'
  import { gitDictList, gitDictVal, TimestampToTime, downLoadXlsx } from '@/utils/tool'
  import { ElMessageBox, ElMessage, ElNotification } from 'element-plus'
  export default {
    name: 'patentList',
    setup() {
      const route = useRoute()
      const state = reactive({
        searchData: {
          patient_id: route.params.id,
        },
        pageData: {
          currentPage: 1,
          pageSize: 10,
          totalSum: 0,
        },
        baseinfo: '',
        idetinfo: [],
        insuinfo: [],
        dataListLoading: false,
      })
      const initData = () => {
        getDataList()
    }
      const getDataList = async () => {
        state.dataListLoading = true
        let res = await service.post(
          '/api/medical/baseinfo',
          state.searchData
        )
        state.dataListLoading = false
        if (res.code === 0) {
          state.baseinfo = res.data.baseinfo
          state.insuinfo = res.data.insuinfo
          state.idetinfo = res.data.idetinfo
        }
      }

      return {
        ...toRefs(state),
        getDataList,
        initData
      }
    },
  }
</script>
<style lang="scss">
  .el-notification__group {
    flex: 1;
  }

  .notice_but {
    text-align: right;
    color: #3167a8;
    cursor: pointer;
  }
</style>
<style scoped lang="scss">
  .demo-form-inline {
    margin-top: 0;
    //flex: 1;
    display: grid;
    grid-template-columns: 25% 25% 25% 25%;
    grid-template-rows: repeat(1, 40px);
    align-items: center;

    .el-form-item {
      margin-bottom: 0;
    }
  }

  .search-top .w-208 {
    width: 208px;
  }

  .table-tag {
    margin-right: 8px;
  }

  .fa-stack {
    width: 24px;
    height: 24px;
    cursor: pointer;
    float: right;

    .fa-stack-2x {
      font-size: 24px;
      color: rgba(49, 102, 174, 0.1);
    }

    .fa-stack-1x {
      font-size: 12px;
      color: #3166ae;
      line-height: 24px;
    }
  }

  .tagBox {
    display: flex;
    justify-content: flex-start;

    // margin-bottom: 10px;
    .tit {
      width: 83px;
      font-size: 14px;
      font-family: 'Source Han Sans CN-Bold';
      font-weight: bold;
      color: #666666;
    }

    .cont {
      width: calc(100% - 83px);
    }
  }

  .patientList {
    margin-top: 4px;
    height: calc(100% - 220px);
  }

  .list-top {
    .name {
      font-size: 18px;
      font-family: ' Source Han Sans CN-Medium';
      font-weight: 500;
      color: #000000;
      line-height: 32px;
    }
  }

  .patient-alert {
    background: rgba(49, 102, 174, 0.1);
    border-radius: 4px 4px 4px 4px;
    font-size: 18px;
    color: #3166ae;
    margin-top: 8px;
    padding: 4px 16px;

    .el-alert__icon {
      color: #3166ae;
    }

    &:deep(.el-alert__content) {
      position: relative;
      top: 3px;
    }
  }

  .table {
    margin-top: 10px;
    height: calc(100% - 10px);

    .img {
      width: 25px;
      height: 24px;
      margin-right: 14px;
    }
  }

  .searchBut {
    width: 100%;
    display: flex;
    justify-content: end;
    margin-right: 28px;
  }

  .del {
    background-color: #ffecec;
    color: #ff6b6b;
    font-weight: 700;
  }

  .modify {
    background-color: #3166ae;
  }

  .bar-title {
    font-size: 18px;
    line-height: 18px;
    color: #000000;
    border-left: 6px solid #3166ae;
    padding: 0 18px;
    margin-bottom: 16px;
    font-weight: bold;
  }

  .labelSet1 {
    width: 60px;
    height: 30px;
    line-height: 30px;
    display: block;
    text-align: center;
    color: #fff;
    border-radius: 5px;
  }

  .psckset {
    background-color: #409EFF;
  }

  .psckset1 {
    background-color: #a4cef8;
    color: #1581fc;
    border: 1px solid #1581fc;
  }

  .lcsyset {
    background-color: #c6f1b1;
    color: #3bb207;
    border: 1px solid #5bd324;
  }

  .lcsyset1 {
    background-color: #f1beb1;
    color: #f35c0c;
    border: 1px solid #f35c0c;
  }

  .info-table {
    width: 100%;
    margin: 10px 0;

    tr {
      height: 40px;
    }

    td {
      padding-left: 20px;
    }

    .color-blue {
      color: #3166ae;
      font-size: 14px;
      width: 160px;
    }

    .border-right {
      border-right: 1px solid gray;
    }

  }

  .info-table tr:nth-child(2n+1) {
    background-color: rgba(49, 102, 174, 0.1);
  }

  .momey-total {
    display: flex;
    margin: 10px;
    line-height: 30px;
    font-size: 14px;

    .item {
      margin-right: 20px;
      width: 150px;
      color: #444;
    }
  }

  .momey-total1 {
    display: flex;
    margin: 10px;
    line-height: 30px;
    font-size: 14px;

    .item1 {
      margin-right: 20px;
      width: 350px;
      color: #444;
    }

    .item {
      margin-right: 20px;
      width: 250px;
      color: #444;
    }
  }
</style>